import axios from "axios";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import { useState } from "react";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Alert from "@mui/material/Alert";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import { useNavigate } from "react-router-dom";
import { apiURI, authErrorRedirect } from "../../common";
import { validateSupplierNameInput } from "../validation/validateSupplierNameInput";

export function AddSupplierToMasterDialog(props) {
  const history = useNavigate();

  const handleClose = () => {
    props.setOpen(false);
  };
  const [errors, setErrors] = useState();

  async function handleSaveEditedItem(formData) {
    const { supplierName, supplierNumber } = formData;
    setErrors();
    const supplier = `${supplierNumber.trim()} - ${supplierName.trim()}`;
    await axios
      .post(`${apiURI}/form/addSupplierToMasterList`, { supplier })
      .then(() => window.location.reload(true))
      .catch((response) => {
        setErrors();
        setErrors({ response: response.response.data });
        authErrorRedirect(response.response.data, history);
      });
    // eslint-disable-next-line no-console
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const formData = {
      supplierNumber: data.get("supplierNumberToAdd"),
      supplierName: data.get("supplierNameToAdd"),
    };

    const { validationErrors, isValid } = validateSupplierNameInput(formData);
    !isValid && setErrors(validationErrors);

    isValid && handleSaveEditedItem(formData);
  };
  errors && console.log({ errors });

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={handleClose}
        style={{
          height: "90%",
        }}
        PaperProps={{ sx: { borderRadius: "20px" } }}
      >
        <Box
          sx={{
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Container
            component="main"
            maxWidth="sm"
            sx={{
              marginTop: 4,
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography component="h1" variant="h5">
              Add Supplier to supplier list master
            </Typography>
            <CssBaseline />
            <Box
              component="form"
              noValidate
              sx={{
                mt: 5,
              }}
              onSubmit={handleSubmit}
            >
              <TextField
                autoFocus
                margin="dense"
                name="supplierNumberToAdd"
                id="supplierNumberToAdd"
                label="Supplier Number"
                fullWidth
                required
                error={errors?.supplierNumber && true}
                helperText={
                  errors?.supplierNumber !== "" ? errors?.supplierNumber : ""
                }
              />
              <TextField
                autoFocus
                margin="dense"
                name="supplierNameToAdd"
                id="supplierNameToAdd"
                label="Supplier Name"
                fullWidth
                required
                error={errors?.supplierName && true}
                helperText={
                  errors?.supplierName !== "" ? errors?.supplierName : ""
                }
              />
              {errors?.response && (
                <Alert
                  severity="error"
                  sx={{
                    mt: 2,
                  }}
                >
                  {errors?.response !== "" ? errors?.response : " "}
                </Alert>
              )}
              <Grid
                container
                spacing={2}
                sx={{
                  mt: 1,
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                <Grid item>
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{
                      mt: 3,
                      mb: 3,
                      width: "150px",
                    }}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Container>
        </Box>
      </Dialog>
    </div>
  );
}
